"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const commitmentHistory_1 = require("./commitmentHistory");
const deal_1 = require("./deal");
const investor_1 = require("./investor");
const commitment_1 = require("./commitment");
const portfolio_1 = require("./portfolio");
const quiz_1 = require("./quiz");
const entity_1 = require("./entity");
const kyc_1 = require("./kyc");
const documents_1 = require("./documents");
const payments_1 = require("./payments");
const user_bank_account_1 = require("./user-bank-account");
const liquidation_1 = require("./liquidation");
const withdrawal_1 = require("./withdrawal");
const investment_1 = require("./investment");
const dividend_1 = require("./dividend");
const currencyConversionRate_1 = require("./currencyConversionRate");
const zakat_1 = require("./zakat");
exports.default = {
  deleteEntityDocument: entity_1.deleteEntityDocument,
  deleteKYCDocument: kyc_1.deleteKYCDocument,
  downloadInvestmentStatementDocument: documents_1.downloadInvestmentStatementDocument,
  downloadInvestmentStatementDocumentV2: documents_1.downloadInvestmentStatementDocumentV2,
  downloadPerformanceOverviewDocument: documents_1.downloadPerformanceOverviewDocument,
  downloadPortfolioOverviewDocument: documents_1.downloadPortfolioOverviewDocument,
  getAccreditationQuestionnaire: investor_1.getAccreditationQuestionnaire,
  getCommitmentHistory: commitmentHistory_1.getCommitmentHistory,
  getCommitmentPreview: commitment_1.getCommitmentPreview,
  getCommitments: commitment_1.getCommitments,
  getPendingPayments: commitment_1.getPendingPayments,
  getDeal: deal_1.getDeal,
  getDeals: deal_1.getDeals,
  getDealsV2: deal_1.getDealsV2,
  getEntities: entity_1.getEntities,
  getInvestor: investor_1.getInvestor,
  getPaymentHistories: commitment_1.getPaymentHistories,
  getPortfolio: portfolio_1.getPortfolio,
  getQuiz: quiz_1.getQuiz,
  membershipCheckoutSession: payments_1.membershipCheckoutSession,
  postCommitment: commitment_1.postCommitment,
  postPayment: commitment_1.postPayment,
  onboardInvestor: investor_1.onboardInvestor,
  postEntity: entity_1.postEntity,
  postEntityBankAccount: entity_1.postEntityBankAccount,
  postNPS: investor_1.postNPS,
  postMarketingPreferences: investor_1.postMarketingPreferences,
  postQuiz: quiz_1.postQuiz,
  postSourceOfFundDescription: kyc_1.postSourceOfFundDescription,
  reaccreditateInvestor: investor_1.reaccreditateInvestor,
  uploadEntityDocument: entity_1.uploadEntityDocument,
  uploadKYCDocument: kyc_1.uploadKYCDocument,
  getReturnCalculator: deal_1.getReturnCalculator,
  getReturnCalculatorV2: deal_1.getReturnCalculatorV2,
  generateZakatStatement: documents_1.generateZakatStatement,
  getDocuments: documents_1.getDocuments,
  signDocument: documents_1.signDocument,
  getUserBankAccounts: user_bank_account_1.getUserBankAccounts,
  postUserBankAccount: user_bank_account_1.postUserBankAccount,
  putUserBankAccount: user_bank_account_1.putUserBankAccount,
  deleteUserBankAccount: user_bank_account_1.deleteUserBankAccount,
  findLiquidationById: liquidation_1.findLiquidationById,
  createLiquidation: liquidation_1.createLiquidation,
  findWithdrawalById: withdrawal_1.findWithdrawalById,
  getMandatoryQuestionnaire: investor_1.getMandatoryQuestionnaire,
  submitMandatoryQuestionnaire: investor_1.submitMandatoryQuestionnaire,
  findInvestmentById: investment_1.findInvestmentById,
  findDividendById: dividend_1.findDividendById,
  getCurrencyConversionRates: currencyConversionRate_1.getCurrencyConversionRates,
  getCurrencyConversionRatesV2: currencyConversionRate_1.getCurrencyConversionRatesV2,
  getCurrencyConversionRatesBySourceCurrency: currencyConversionRate_1.getCurrencyConversionRatesBySourceCurrency,
  updateZakat: zakat_1.updateZakat,
  createZakatAsset: zakat_1.createZakatAsset,
  updateZakatAsset: zakat_1.updateZakatAsset,
  createZakatLiability: zakat_1.createZakatLiability,
  updateZakatLiability: zakat_1.updateZakatLiability,
  deleteZakatAsset: zakat_1.deleteZakatAsset,
  deleteZakatLiability: zakat_1.deleteZakatLiability,
  getNisab: zakat_1.getNisab,
  getZakat: zakat_1.getZakat,
  getZakatPortfolio: zakat_1.getZakatPortfolio,
  createZakatPayment: zakat_1.createZakatPayment
};